import dayjs from 'dayjs';
import * as echarts from 'echarts';
import { getRandomNum } from '@/utils';

const today = new Date();
const days = [];
const waterData = [];
const eleData = [];
for (let i = 0; i < 7; i++) {
  const day = dayjs(today).subtract(i, 'day').format('MM-DD');
  const water = getRandomNum(500, 600);
  const ele = getRandomNum(500, 600);
  days.unshift(day);
  waterData.push(water);
  eleData.push(ele);
}
export const eleOpHome = {
  grid: {
    top: '20%',
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true,
  },
  tooltip: {
    trigger: 'item',
  },
  xAxis: {
    type: 'category',
    boundaryGap: true,
    data: days,
    //x 轴线的颜色以及宽度
    show: true,
    lineStyle: {
      color: '#a8afb9',
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      //x 轴文字的配置
      show: true,
      textStyle: {
        color: '#a8afb9',
      },
    },
  },
  yAxis: {
    name: '当年发电量/kWh',
    nameTextStyle: { color: '#86AAC4' },
    type: 'value',
    axisLine: {
      //y 轴线的颜色以及宽度
      show: false,
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      //y 轴文字的配置
      show: true,
      textStyle: {
        color: '#a8afb9',
      },
    },
    splitLine: {
      show: false,
    },
  },
  series: [
    {
      data: eleData,
      type: 'bar',
      barWidth: 20,
      showBackground: true,
      itemStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          { offset: 0, color: '#83bff6' },
          { offset: 0.5, color: '#188df0' },
          { offset: 1, color: '#188df0' },
        ]),
      },
      emphasis: {
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#2378f7' },
            { offset: 0.7, color: '#2378f7' },
            { offset: 1, color: '#83bff6' },
          ]),
        },
      },
      smooth: true,
    },
  ],
};

export const eleOp = {
  grid: {
    top: '20%',
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true,
  },
  tooltip: {
    trigger: 'item',
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: days,
    //x 轴线的颜色以及宽度
    show: true,
    lineStyle: {
      color: '#a8afb9',
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      //x 轴文字的配置
      show: true,
      textStyle: {
        color: '#a8afb9',
      },
    },
  },
  yAxis: {
    name: '水位曲线/m',
    nameTextStyle: { color: '#86AAC4' },
    type: 'value',
    axisLine: {
      //y 轴线的颜色以及宽度
      show: false,
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      //y 轴文字的配置
      show: true,
      textStyle: {
        color: '#a8afb9',
      },
    },
    splitLine: {
      show: false,
    },
  },
  series: [
    {
      data: eleData,
      type: 'line',
      areaStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: 'rgba(255, 217, 77, 0.5)',
          },
          {
            offset: 1,
            color: 'rgba(88,181,249,0)',
          },
        ]),
      },
      lineStyle: {
        color: 'rgba(255, 217, 77, 1)',
      },
      itemStyle: {
        color: 'rgba(255, 217, 77, 1)',
      },
      smooth: true,
    },
  ],
};

export const waterOp = {
  grid: {
    top: '20%',
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true,
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: days,
    //x 轴线的颜色以及宽度
    show: true,
    lineStyle: {
      color: '#a8afb9',
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      //x 轴文字的配置
      show: true,
      textStyle: {
        color: '#a8afb9',
      },
    },
  },
  yAxis: {
    type: 'value',
    axisLine: {
      //y 轴线的颜色以及宽度
      show: false,
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      //y 轴文字的配置
      show: true,
      textStyle: {
        color: '#a8afb9',
      },
    },
    splitLine: {
      show: false,
    },
  },
  series: [
    {
      data: waterData,
      type: 'line',
      areaStyle: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: 'rgba(88,181,249,0.5)',
          },
          {
            offset: 1,
            color: 'rgba(88,181,249,0)',
          },
        ]),
      },
      smooth: true,
    },
  ],
};
